import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=4afb9396&"
import script from "./ImageComponent.vue?vue&type=script&lang=js&"
export * from "./ImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports